import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export default function StepColors({ form, setForm, next, back }) {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-light mb-2" style={{ color: 'var(--text-primary)' }}>
          Brand Colors
        </h1>
        <p className="text-sm font-light" style={{ color: 'var(--text-secondary)' }}>
          Define your airline's primary and accent colors.
        </p>
      </div>

      <div className="space-y-6">
        <div className="space-y-2">
          <Label htmlFor="primary" className="text-sm font-normal" style={{ color: 'var(--text-secondary)' }}>
            Primary Color
          </Label>
          <div className="flex gap-3">
            <Input
              id="primary"
              type="color"
              value={form.colors.primary}
              onChange={(e) => setForm({ 
                ...form, 
                colors: { ...form.colors, primary: e.target.value }
              })}
              className="h-12 w-20 rounded-sm cursor-pointer"
              style={{ backgroundColor: 'var(--bg-panel)', borderColor: 'var(--border)' }}
            />
            <Input
              value={form.colors.primary}
              onChange={(e) => setForm({ 
                ...form, 
                colors: { ...form.colors, primary: e.target.value }
              })}
              className="flex-1 rounded-sm"
              style={{ backgroundColor: 'var(--bg-panel)', borderColor: 'var(--border)', color: 'var(--text-primary)' }}
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="accent" className="text-sm font-normal" style={{ color: 'var(--text-secondary)' }}>
            Accent Color
          </Label>
          <div className="flex gap-3">
            <Input
              id="accent"
              type="color"
              value={form.colors.accent}
              onChange={(e) => setForm({ 
                ...form, 
                colors: { ...form.colors, accent: e.target.value }
              })}
              className="h-12 w-20 rounded-sm cursor-pointer"
              style={{ backgroundColor: 'var(--bg-panel)', borderColor: 'var(--border)' }}
            />
            <Input
              value={form.colors.accent}
              onChange={(e) => setForm({ 
                ...form, 
                colors: { ...form.colors, accent: e.target.value }
              })}
              className="flex-1 rounded-sm"
              style={{ backgroundColor: 'var(--bg-panel)', borderColor: 'var(--border)', color: 'var(--text-primary)' }}
            />
          </div>
        </div>

        <div className="mt-8 p-6 rounded-sm" style={{ borderWidth: '1px', borderColor: 'var(--border)', backgroundColor: 'var(--bg-panel)' }}>
          <div className="text-xs font-light mb-3" style={{ color: 'var(--text-muted)' }}>COLOR PREVIEW</div>
          <div className="flex gap-3">
            <div 
              className="h-16 flex-1 rounded-sm"
              style={{ backgroundColor: form.colors.primary }}
            />
            <div 
              className="h-16 flex-1 rounded-sm"
              style={{ backgroundColor: form.colors.accent }}
            />
          </div>
        </div>
      </div>

      <div className="flex justify-between pt-4" style={{ borderTopWidth: '1px', borderColor: 'var(--border)' }}>
        <Button
          onClick={back}
          variant="outline"
          className="font-normal px-8 rounded-sm"
          style={{ borderColor: 'var(--border)', color: 'var(--text-primary)' }}
        >
          Back
        </Button>
        <Button
          onClick={next}
          className="font-normal px-8 rounded-sm"
          style={{ backgroundColor: 'var(--neon)', color: '#000' }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}